import {
  ArrowBackIosNew,
  FacebookOutlined,
  HomeOutlined,
  Instagram,
  LanguageOutlined,
  PhoneOutlined,
  Twitter,
  WatchLaterOutlined,
  WhatsApp,
  YouTube,
} from "@mui/icons-material";
import {
  Avatar,
  Divider,
  Grid,
  IconButton,
  Link,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../components/loader/Loading";
import { useAppSelector } from "../../context/hooks/hooks";

import TikTokIcon from "../../components/icons/TikTokIcon";
import { formatHours } from "../../utils/date";
import useQueryClubId from "../../utils/hooks/useQueryClubId";
import "./club.scss";
import Map from "../../components/map/Map";

type WeekScheduleItem = {
  start: string;
  end: string;
};

type WeekSchedule = {
  [day: string]: WeekScheduleItem[];
};

const ClubInfo = () => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const matches = useMediaQuery("(width > 769px)");
  const params = useParams();
  const { id } = params;

  const {
    data: clubData,
    isLoading,
    isRefetching,
  } = useQueryClubId(id ? id : userInfo?.clubsIds[0] || "");

  const weekSchedule =
    clubData?.weekSchedule && (JSON.parse(clubData?.weekSchedule) as WeekSchedule);

  return isRefetching || isLoading ? (
    <Loading />
  ) : (
    <Grid container className="club" component={matches ? Paper : Grid}>
      <Grid item xs={12} className="club__first-container" container>
        <IconButton
          onClick={() => {
            navigate("/home");
          }}
          className="club__first-container__button"
        >
          <ArrowBackIosNew /> Ficha {clubData?.shortCode}
        </IconButton>
        <Grid className="club__first-container__image-container">
          <Avatar
            className="club__first-container__image-container__avatar"
            src={clubData?.logoUrl}
          />
        </Grid>
        <Grid item className="club__first-container__text-container">
          <Typography className="club__first-container__text-container__name">
            {clubData?.name}
          </Typography>
          <Typography className="club__first-container__text-container__name">
            {matches && "CIF: "}
            {clubData?.cif}
          </Typography>
        </Grid>
      </Grid>
      <Grid item className="club__second-container" xs={12} sm={8}>
        <Grid className="club__second-container__text">
          {matches ? (
            <Typography className="club__second-container__text__bold">Dirección:</Typography>
          ) : (
            <HomeOutlined />
          )}{" "}
          <Typography>{clubData?.address?.address}</Typography>
        </Grid>
        {matches && <Divider />}
        <Grid className="club__second-container__text">
          {matches ? (
            <Typography className="club__second-container__text__bold">Teléfono:</Typography>
          ) : (
            <PhoneOutlined />
          )}
          <Typography>{clubData?.phone}</Typography>
        </Grid>
        {matches && <Divider />}
        <Grid className="club__second-container__text">
          {matches ? (
            <Typography className="club__second-container__text__bold">Web:</Typography>
          ) : (
            <LanguageOutlined />
          )}{" "}
          <Link
            underline="hover"
            href={clubData?.website}
            target="_blank"
            rel="noreferrer noopener"
            className="club__second-container__text__link"
          >
            {clubData?.website}
          </Link>
        </Grid>
        {clubData?.socialMedia && (
          <>
            {matches && <Divider />}
            {matches && (
              <Typography className="club__second-container__text__bold">
                Redes Sociales:
              </Typography>
            )}
            {clubData?.socialMedia?.facebookUrl && (
              <Link
                className="club__second-container__text"
                underline="hover"
                rel="noopener noreferrer"
                href={clubData?.socialMedia?.facebookUrl}
                target="_blank"
              >
                <FacebookOutlined /> {clubData?.socialMedia?.facebookUrl}
              </Link>
            )}
            {clubData?.socialMedia?.instagramUrl && (
              <Link
                className="club__second-container__text"
                underline="hover"
                rel="noopener noreferrer"
                href={clubData?.socialMedia?.instagramUrl}
                target="_blank"
              >
                <Instagram /> {clubData?.socialMedia?.instagramUrl}
              </Link>
            )}
            {clubData?.socialMedia?.youtubeUrl && (
              <Link
                className="club__second-container__text"
                underline="hover"
                rel="noopener noreferrer"
                href={clubData?.socialMedia?.youtubeUrl}
                target="_blank"
              >
                <YouTube /> {clubData?.socialMedia?.youtubeUrl}
              </Link>
            )}
            {clubData?.socialMedia?.tiktokUrl && (
              <Link
                className="club__second-container__text"
                underline="hover"
                rel="noopener noreferrer"
                href={clubData?.socialMedia?.tiktokUrl}
                target="_blank"
              >
                <TikTokIcon /> {clubData?.socialMedia?.tiktokUrl}
              </Link>
            )}
            {clubData?.socialMedia?.twitterUrl && (
              <Link
                className="club__second-container__text"
                underline="hover"
                rel="noopener noreferrer"
                href={clubData?.socialMedia?.twitterUrl}
                target="_blank"
              >
                <Twitter /> {clubData?.socialMedia?.twitterUrl}
              </Link>
            )}
            {clubData?.socialMedia?.whatsappUrl && (
              <Link
                className="club__second-container__text"
                underline="hover"
                rel="noopener noreferrer"
                href={clubData?.socialMedia?.whatsappUrl}
                target="_blank"
              >
                <WhatsApp /> {clubData?.socialMedia?.whatsappUrl}
              </Link>
            )}
          </>
        )}
        {matches && <Divider />}
        {weekSchedule && (
          <Grid className="club__second-container__text">
            {matches ? (
              <Typography className="club__second-container__text__bold">Horario:</Typography>
            ) : (
              <>
                <WatchLaterOutlined />
                <Typography className="club__second-container__text__bold">Horario:</Typography>
              </>
            )}{" "}
          </Grid>
        )}
        <Grid container className="club__second-container__weekSchedule">
          {weekSchedule &&
            Object.keys(weekSchedule).map((day: string) => (
              <Grid item key={day}>
                {day}:
                {weekSchedule[day] &&
                  weekSchedule[day].length > 0 &&
                  weekSchedule[day].map((schedule: any, index: number) => (
                    <span key={index}>
                      {" "}
                      {`${formatHours(schedule.start)} - ${formatHours(schedule.end)}`}
                      {index !== weekSchedule[day].length - 1 && ", "}
                    </span>
                  ))}
              </Grid>
            ))}
        </Grid>
      </Grid>
      {clubData?.mapsUrl && (
        <Grid className="club__container-map" item xs={12}>
          <Typography className="club__second-container__text">Mapa:</Typography>
          {/* <Grid className="club__container-map__map">
            <iframe
              src={clubData?.mapsUrl}
              width="80%"
              height="100%"
              aria-hidden="false"
              title="google maps iframe"
            />
          </Grid> */}
          <Grid className="map_container">
            <Map lat={clubData.latitude} lng={clubData.longitude} />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default ClubInfo;
